import { BreadcrumbItem, Col, Row } from "reactstrap"
import { Link } from "react-router-dom"

import PropTypes from "prop-types"
import React from "react";
import { USER_TYPES } from "helpers/sf_constants";
import { useSelector } from "react-redux";
import SfNavLink from "components/Common/SfNavLink";

const WhitelabeledBrandsBreadcrumb = ({breadcrumbItem}) => {

    const {
        current_user
     } = useSelector((state) => {
        return {
           current_user: state.LoginAdminUser.current_user,
        }
     });

    const isCurrentUserSuperAdmin = () => {
        return current_user?.admin_role?.name.toLowerCase() === USER_TYPES.SUPER_ADMIN.toLowerCase()
    }

    return (
        <Row>
        <Col md={12} xs="12">
        <div className="page-title-box pb-2 d-sm-flex align-items-center justify-content-between">
          <h4 className="text-capitalize text-black mb-0 font-size-18">
            Whitelabeled Brands
          </h4>
          {
            breadcrumbItem === 'Users' &&
          
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="#" className="text-black">Whitelabeled Brands</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to="#" className="text-black">{breadcrumbItem}</Link>
              </BreadcrumbItem>
            </ol>
          </div>
          }
        </div>
      </Col>
            <Col md={12} xs={12}>
                <Row>
                    <Col md="8" xs="8">
                        <ul className="nav sfnav mb-3">
                            <li className="nav-item">
                                <SfNavLink
                                    isURL={true}
                                    url={`/whitelabeled_brands`}
                                    tabName='Brands'
                                />
                            </li>
                            {
                                isCurrentUserSuperAdmin() &&
                                <li className="nav-item">
                                    <SfNavLink
                                        isURL={true}
                                        url={`/whitelabeled_brands_users`}
                                        tabName='Users'
                                    />
                                </li>
                            }
                        </ul>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

WhitelabeledBrandsBreadcrumb.propTypes = {
    breadcrumbItem: PropTypes.string,
    title: PropTypes.string,
}
export default WhitelabeledBrandsBreadcrumb
